import React, { useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';

import BaseActionForm from '../BaseActionForm';
import { Button, Dropdown } from "react-bootstrap";
import DatasetUtils from "../../services/DatasetUtils";
import './styles.scss'
import BackArrow from './../../assets/BackArrow.svg'
import DragIcon from './../../assets/dragIcon.svg'
import FilterIcon from './../../assets/filterIcon.svg'
import SortUp from './../../assets/sortUp.svg'
import SortDown from './../../assets/sortDown.svg'

import { updateMyDatasets, selectDataset } from "../../services/StoreContainer/actionCreators";
import * as actionTypes from "../../services/StoreContainer/actionTypes";

import {
    sortableContainer,
    sortableElement,
    sortableHandle,
} from 'react-sortable-hoc';

export default function TuneMetadata(props) {
    const navigation = useNavigate()
    const datasetsContainer = useSelector((store) => { return store.datasetsReducer })
    const dispatch = useDispatch();

    const navigateBack = () => {
        navigation('..', {
            relative: 'route',
            replace: true
        });
    }

    // consume the history.location.state and reset the state
    // window.history.replaceState({}, document.title)
    return <TuneMetadataClass {...props}
        navigation={navigation}
        navigateBack={navigateBack}
        dispatch={dispatch}
        datasetsContainer={datasetsContainer}
    />//pass to your component.
}
class TuneMetadataClass extends BaseActionForm {

    //TODO: если поменять перетаскиванием последние два поля, вылет по Cannot read properties of null (reading 'removeChild')

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            dataset: null,
            fields: null,
            newFieldName: "",
            newFieldError: null,
            datasetName: "",
            items: ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5', 'Item 6'],
        }
    }

    STANDART_FIELDS = {
        'Адрес в ОАП': [
            {
                name: 'oarObject.ID',
                caption: 'Идентификатор ОАП',
                type: 'string'
            },
            {
                name: 'oarObject.Region',
                caption: 'Регион в ОАП',
                type: 'string',
                feature: 'Region',
            },
            {
                name: 'oarObject.Municipalitet',
                caption: 'Город в ОАП',
                type: 'string',
                feature: 'Municipalitet',
            },
            {
                name: 'oarObject.Street',
                caption: 'Улица в ОАП',
                type: 'string',
                feature: 'Street'
            },
            {
                name: 'oarObject.HouseNumber',
                caption: 'Номер дома в ОАП',
                type: 'string',
                feature: 'HouseNumber'
            }
        ],
        'Геометрия из ОАП': [
            {
                name: 'oarObject.Geometry',
                caption: 'Геометрия из ОАП',
                type: 'geometry',
                feature: 'Geometry'
            }
        ],
        'Качество связей с ОАП': [
            {
                name: 'oarObject.connection.weight',
                caption: 'Вес связи',
                type: 'double'
            },
            {
                name: 'oarObject.connection.quality',
                caption: 'Точность связи',
                type: 'string'
            },
            {
                name: 'oarObject.connection.duplicate',
                caption: 'Множество к одному',
                type: 'string'
            }
        ],
        'Почтовый индекс': [
            {
                name: 'oarObject.PostalCode',
                caption: 'Почтовый индекс в ОАП',
                type: 'string'
            }
        ],
        'Транспортная доступность': [
            {
                name: 'oarObject.transportAccessibility',
                caption: 'Транспортная доступность',
                type: 'double'
            }
        ],
        'Автомобильная доступность': [
            {
                name: 'oarObject.AutoAccessibility',
                caption: 'Автомобильная доступность',
                type: 'double'
            }
        ],
        'Количество жителей': [
            {
                name: 'oarObject.peopleCount',
                caption: 'Количество жителей',
                type: 'int'
            }
        ],
        'Количество квартир': [
            {
                name: 'oarObject.flatsCount',
                caption: 'Количество квартир',
                type: 'int'
            }
        ],
        'Тип здания': [
            {
                name: 'oarObject.buildingType',
                caption: 'Тип здания',
                type: 'string'
            }
        ],
        'Кафе/рестораны рядом': [
            {
                name: 'oarObject.foodOrgs',
                caption: 'Кафе/рестораны рядом',
                type: 'int'
            }
        ],
        'Общеобразовательные организации рядом': [
            {
                name: 'oarObject.educationOrgs.orgName',
                caption: 'Общеобразовательные организации рядом',
                type: 'string'
            }
        ],


        'Адрес в старом АП': [
            {
                name: 'oarObject.oldAPAddress.ID',
                caption: 'Идентификатор в старом АП',
                type: 'string'
            },
            {
                name: 'oarObject.oldAPAddress.Municipalitet',
                caption: 'Город в старом АП',
                type: 'string',
                feature: 'Municipalitet'
            },
            {
                name: 'oarObject.oldAPAddress.Street',
                caption: 'Улица в старом АП',
                type: 'string',
                feature: 'Street'
            },
            {
                name: 'oarObject.oldAPAddress.HouseNumber',
                caption: 'Номер дома в старом АП',
                type: 'string',
                feature: 'HouseNumber'
            }
        ],


        'Адрес в ОКС': [
            {
                name: 'oarObject.oksAddress.ID',
                caption: 'Кадастровый номер ОКС',
                type: 'string'
            },
            {
                name: 'oarObject.oksAddress.Municipalitet',
                caption: 'Город в ОКС',
                type: 'string',
                feature: 'Municipalitet'
            },
            {
                name: 'oarObject.oksAddress.Street',
                caption: 'Улица в ОКС',
                type: 'string',
                feature: 'Street'
            },
            {
                name: 'oarObject.oksAddress.HouseNumber',
                caption: 'Номер дома в ОКС',
                type: 'string',
                feature: 'HouseNumber'
            }
        ],

        'Характеристики ОКС': [
            {
                name: 'oarObject.oksAddress.builtYear',
                caption: 'Год постройки в ОКС',
                type: 'string'
            }
        ],

        'Адрес в ФИАС': [
            {
                name: 'oarObject.fiasAddress.ID',
                caption: 'Идентификатор дома в ФИАС',
                type: 'string'
            },
            {
                name: 'oarObject.fiasAddress.Municipalitet',
                caption: 'Город в ФИАС',
                type: 'string',
                feature: 'Municipalitet'
            },
            {
                name: 'oarObject.fiasAddress.Street',
                caption: 'Улица в ФИАС',
                type: 'string',
                feature: 'Street'
            },
            {
                name: 'oarObject.fiasAddress.HouseNumber',
                caption: 'Номер дома в ФИАС',
                type: 'string',
                feature: 'HouseNumber'
            }
        ],

        'Тип дома в ФИАС': [
            {
                name: 'oarObject.fiasAddress.HouseType',
                caption: 'Тип дома в ФИАС',
                type: 'string'
            }
        ],

        'Адрес в ОСМ': [
            {
                name: 'oarObject.osmAddress.ID',
                caption: 'Идентификатор в OSM',
                type: 'string'
            },
            {
                name: 'oarObject.osmAddress.Municipalitet',
                caption: 'Город в OSM',
                type: 'string',
                feature: 'Municipalitet',
            },
            {
                name: 'oarObject.osmAddress.Street',
                caption: 'Улица в OSM',
                type: 'string',
                feature: 'Street'
            },
            {
                name: 'oarObject.osmAddress.HouseNumber',
                caption: 'Номер дома в OSM',
                type: 'string',
                feature: 'HouseNumber'
            }
        ],

        'Тип дома в ОСМ': [
            {
                name: 'oarObject.osmAddress.BuildingType',
                caption: 'Тип дома в OSM',
                type: 'string'
            }
        ],

        'Этажность в ОСМ': [
            {
                name: 'oarObject.osmAddress.floorsCount',
                caption: 'Этажность в OSM',
                type: 'string'
            }
        ],

        'Адрес в ЗУ': [
            {
                name: 'oarObject.landsAddress.ID',
                caption: 'Кадастровый номер ЗУ',
                type: 'string'
            },
            {
                name: 'oarObject.landsAddress.Municipalitet',
                caption: 'Город в ЗУ',
                type: 'string',
                feature: 'Municipalitet',
            },
            {
                name: 'oarObject.landsAddress.Street',
                caption: 'Улица в ЗУ',
                type: 'string',
                feature: 'Street'
            },
            {
                name: 'oarObject.landsAddress.HouseNumber',
                caption: 'Номер дома в ЗУ',
                type: 'string',
                feature: 'HouseNumber'
            }
        ],

        'Характеристики ЗУ': [
            {
                name: 'oarObject.landsAddress.Allowed',
                caption: 'ВРИ ЗУ',
                type: 'string'
            },
            {
                name: 'oarObject.landsAddress.AllowedCode',
                caption: 'Код ВРИ ЗУ',
                type: 'string'
            },
            {
                name: 'oarObject.landsAddress.Square',
                caption: 'Площадь ЗУ',
                type: 'double'
            }
        ],

        'Адрес в ГАС Выборы': [
            {
                name: 'oarObject.flatsCount.ID',
                caption: 'Идентификатор дома в ГАС Выборы',
                type: 'string'
            },
            {
                name: 'oarObject.flatsCount.Municipalitet',
                caption: 'Город в ГАС Выборы',
                type: 'string',
                feature: 'Municipalitet'
            },
            {
                name: 'oarObject.flatsCount.Street',
                caption: 'Улица в ГАС Выборы',
                type: 'string',
                feature: 'Street'
            },
            {
                name: 'oarObject.flatsCount.HouseNumber',
                caption: 'Номер дома в ГАС Выборы',
                type: 'string',
                feature: 'HouseNumber'
            }
        ],

        'Количество квартир в ГАС Выборы': [
            {
                name: 'oarObject.flatsCount.flatsCount',
                caption: 'Количество квартир в ГАС Выборы',
                type: 'int'
            },
            {
                name: 'oarObject.flatsCount.maxFlatNumber',
                caption: 'Макс.номер квартиры в ГАС Выборы',
                type: 'int'
            }
        ],

        'Адрес в РеформаЖКХ': [
            {
                name: 'oarObject.reformagkhAddress.ID',
                caption: 'Идентификатор дома в РеформаЖКХ',
                type: 'string'
            },
            {
                name: 'oarObject.reformagkhAddress.Municipalitet',
                caption: 'Город в РеформаЖКХ',
                type: 'string',
                feature: 'Municipalitet'
            },
            {
                name: 'oarObject.reformagkhAddress.Street',
                caption: 'Улица в РеформаЖКХ',
                type: 'string',
                feature: 'Street'
            },
            {
                name: 'oarObject.reformagkhAddress.HouseNumber',
                caption: 'Номер дома в РеформаЖКХ',
                type: 'string',
                feature: 'HouseNumber'
            }
        ],

        'Характеристики из РеформаЖКХ': [
            {
                name: 'oarObject.reformagkhAddress.houseType',
                caption: 'Тип дома в РеформаЖКХ',
                type: 'string'
            },
            {
                name: 'oarObject.reformagkhAddress.flatsCount',
                caption: 'Количество квартир в РеформаЖКХ',
                type: 'int'
            },
            {
                name: 'oarObject.reformagkhAddress.livingFlatsCount',
                caption: 'Количество жилых квартир в РеформаЖКХ',
                type: 'int'
            },
            {
                name: 'oarObject.reformagkhAddress.floorsCount',
                caption: 'Этажность в РеформаЖКХ',
                type: 'int'
            },
            {
                name: 'oarObject.reformagkhAddress.entranceCount',
                caption: 'Количество подъездов в РеформаЖКХ',
                type: 'int'
            },
            {
                name: 'oarObject.reformagkhAddress.areaTotal',
                caption: 'Общая площадь в РеформаЖКХ',
                type: 'double'
            },
            {
                name: 'oarObject.reformagkhAddress.areaResidential',
                caption: 'Жилая площадь в РеформаЖКХ',
                type: 'double'
            },
            {
                name: 'oarObject.reformagkhAddress.builtYear',
                caption: 'Год постройки в РеформаЖКХ',
                type: 'double'
            }
        ],
    };

    TYPES = {
        string: "строковое",
        int: "целое число",
        double: "дробное число",
        geometry: "геометрия",
        oarObject: "объект ОАР"
    };
    FEATURES = {
        // ID: "Идентификатор",
        Address: "Адрес полностью",
        Region: "Регион",
        Municipalitet: "Населенный пункт",
        Street: "Улица",
        HouseNumber: "Номер дома",
        x: "X центра",
        y: "Y центра",
        Geometry: "Геометрия",
        CadNumber: "Кадастровый номер"
    };


    async componentDidMount() {
        super.componentDidMount();


        let dataset = this.props.datasetsContainer.selectedDataset;

        if (!dataset) {
            //TODO: и все же остается редкая возможность, что в lastDatasets ничего нет,
            //или там датасеты другого автора (перелогинивались)
            //или вообще кинули ссылку на /lk/DatasetTable постороннему человеку
            const datasetsFromLS = localStorage.getItem('lastDatasets');
            if (datasetsFromLS) {
                const lastDatasets = JSON.parse(datasetsFromLS);
                if (lastDatasets && (lastDatasets.length > 0)) {
                    let datasetKey = lastDatasets[0].dataset;
                    if (this.props.datasetsContainer.datasets) {
                        dataset = this.props.datasetsContainer.datasets.find(d => (d.dataset === datasetKey));
                    } else {
                        const res = await this.lkApi.getDatasets({ filter: { 'dataset': datasetKey } });
                        dataset = res.datasets[0]
                    }
                }
            }

            if (dataset) {
                this.props.dispatch(selectDataset(dataset));
            }
        }

        dataset && this.initFields(dataset);

        window.addEventListener('wheel', this.handleScroll);
        window.addEventListener('scroll', this.handleScroll);
    }

    initFields(dataset) {
        let fields = dataset.fields ? dataset.fields : [];
        fields.forEach((field, index) => {
            field.sortNumber = index;
        })

        this.setState({
            dataset: dataset,
            fields: fields.slice(),
            allFields: fields.slice(),
            datasetName: dataset.name ? dataset.name : null
        })
    }

    componentWillUnmount() {
        window.removeEventListener('wheel', this.handleScroll);
        window.removeEventListener('scroll', this.handleScroll);
        if (this.state.dataset) {
            localStorage.removeItem(`tableScrollLeftTuneMetadata_${this.state.dataset.dataset}`);
            localStorage.removeItem(`tableScrollTopTuneMetadata_${this.state.dataset.dataset}`);
        }
    }


    componentWillMount() {
        if (this.state.dataset) {
            localStorage.removeItem(`tableScrollLeftTuneMetadata_${this.state.dataset.dataset}`);
            localStorage.removeItem(`tableScrollTopTuneMetadata_${this.state.dataset.dataset}`);
        }
    }

    handleScroll = () => {
        let tableContent = document.getElementById('sortableContainer');
        if (tableContent) {
            tableContent.addEventListener('scroll', (e) => {
                localStorage.setItem(`tableScrollLeftTuneMetadata_${this.state.dataset.dataset}`, e.target.scrollLeft)
                localStorage.setItem(`tableScrollTopTuneMetadata_${this.state.dataset.dataset}`, e.target.scrollTop)
            })
        }
    }

    componentWillUpdate() {

        let dataset = this.props.datasetsContainer.selectedDataset;
        if (!dataset) {
            const datasetsFromLS = localStorage.getItem('lastDatasets');
            if (datasetsFromLS) {
                const lastDatasets = JSON.parse(datasetsFromLS);
                if (lastDatasets && (lastDatasets.length > 0)) {
                    let datasetKey = lastDatasets[0].dataset;
                    if (
                        this.props.datasetsContainer.datasets
                        && this.props.datasetsContainer.selectedDataset
                        && this.props.datasetsContainer.selectedDataset.dataset !== datasetKey
                    ) {
                        dataset = this.props.datasetsContainer.datasets.find(d => (d.dataset === datasetKey));
                    }
                }
            }
        } else if (
            this.state.dataset
            && this.props.datasetsContainer.datasets
            && this.props.datasetsContainer.selectedDataset
            && this.props.datasetsContainer.selectedDataset.dataset !== this.state.dataset.dataset
        ) {
            this.setState({
                dataset: dataset
            }, () => this.initFields(dataset));
        }

        let tableContent = document.getElementById('sortableContainer')
        if (tableContent) {
            localStorage.setItem(`tableScrollLeftTuneMetadata_${this.state.dataset.dataset}`, tableContent.scrollLeft);
            localStorage.setItem(`tableScrollTopTuneMetadata_${this.state.dataset.dataset}`, tableContent.scrollTop);
        }
    }

    componentDidUpdate() {
        if (this.state.dataset) {
            let tableContent = document.getElementById('sortableContainer')
            let scrollLeft = localStorage.getItem(`tableScrollLeftTuneMetadata_${this.state.dataset.dataset}`)
            let scrollTop = localStorage.getItem(`tableScrollTopTuneMetadata_${this.state.dataset.dataset}`)
            if (tableContent) {
                tableContent.scrollLeft = scrollLeft
                tableContent.scrollTop = scrollTop
            }
        }
    }

    changeField = (field, caption = null, type = null, feature = null, deleteField = false) => {
        if (field) {
            let indexFirst, indexSecond
            let allfields = this.state.allFields
            allfields.forEach((fieldTmp, index) => {
                if (fieldTmp.name === field.name) indexFirst = index
            })

            let fields = this.state.fields
            fields.forEach((fieldTmp, index) => {
                if (fieldTmp.name === field.name) indexSecond = index
            })

            if (caption) {
                allfields[indexFirst].caption = caption
                fields[indexSecond].caption = caption
            }
            if (type) {
                allfields[indexFirst].type = type
                fields[indexSecond].type = type
            }
            if (feature) {

                allfields.forEach((fieldTmp, index) => {
                    if (fieldTmp.feature === feature) {
                        allfields[index].feature = undefined
                        fields[index].feature = undefined
                    }
                })

                if (feature === 'zero') {
                    allfields[indexFirst].feature = undefined
                    fields[indexSecond].feature = undefined
                }
                else {
                    allfields[indexFirst].feature = feature
                    fields[indexSecond].feature = feature
                }
            }
            if (deleteField) {
                allfields.splice(indexSecond, 1);
                fields.splice(indexSecond, 1);
            }

            this.setState({ allFields: allfields, fields: fields }, () => {
                if (caption && document.getElementById('input' + field.name)) {
                    document.getElementById('input' + field.name).focus()
                }
            });
        }
    }

    setNewFieldName = (name) => {
        let exists = false;
        this.state.fields.forEach((field) => {
            if (field.name === name) {
                exists = true;
            }
        });

        this.setState({
            newFieldName: name,
            newFieldError: (exists ? "Такое поле уже есть" : null)
        });
    }

    addNewField = (name, caption, type, feature) => {
        console.log('addNewField')
        let fieldName = (name && (name.length > 0)) ? name :
            (this.state.newFieldName && (this.state.newFieldName.length > 0)) ? this.state.newFieldName : null;

        if (fieldName && (fieldName.length > 0)) {
            let exists = false;
            this.state.allFields.forEach((field) => {
                if (field.name === fieldName) {
                    exists = true;
                }
            });

            if (exists) {
                this.setState({
                    newFieldError: "Такое поле уже есть"
                });
            }
            else {
                let newField = {
                    "name": fieldName,
                    "caption": caption ? caption : fieldName,
                    "type": type ? type : "string",
                    "sortNumber": this.state.allFields.length
                };
                let fields = this.state.fields;
                fields.push(newField);

                if (feature) {
                    for (let i = 0; i < fields.length; i++) {
                        if (fields[i].feature === feature) {
                            fields[i].feature = undefined;
                        }
                    }
                    fields.feature = feature
                }

                let allFields = this.state.allFields;
                allFields.push(newField);

                if (feature) {
                    for (let i = 0; i < allFields.length; i++) {
                        if (allFields[i].feature === feature) {
                            allFields[i].feature = undefined;
                        }
                    }
                    allFields.feature = feature;
                }

                this.setState({
                    fields: fields,
                    allFields: allFields,
                    newFieldName: "",
                    newFieldError: null
                }, () => {
                    let container = document.getElementById('sortableContainer');
                    container && container.scrollTo(0, container.scrollHeight)
                });
            }
        }
    }

    saveStructure = () => {
        if (this.state.dataset && this.state.allFields) {
            this.startLoading();
            this.lkApi.updateDatasetMetadata(
                { fields: this.state.allFields },
                this.state.dataset.dataset,
                { datasetName: this.state.datasetName }
            ).then((response) => {
                if (this.checkStatus(response)) {
                    let finish = null
                    if (response.updated) {
                        finish = 'Cохранено';
                    } else {
                        finish = 'Ошибка';
                    }

                    this.props.dispatch(updateMyDatasets());
                    // this.addAlert(response);
                    this.setState({ afterSave: finish }, () => {
                        setTimeout(() => this.setState({ afterSave: null }), 2000)
                    })
                } else this.stopLoading();
            });
        }
    }

    byField = (field) => {
        return (a, b) => a[field] > b[field] ? 1 : -1;
    }

    byFieldDown = (field) => {
        return (a, b) => a[field] > b[field] ? -1 : 1;
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        let fields = this.state.fields
        let allfields = this.state.allFields
        let dragField = fields[oldIndex]
        fields.splice(oldIndex, 1)
        fields.splice(newIndex, 0, dragField)
        if (!this.state.filterCaption && !this.state.filterField) {
            fields.forEach((field, index) => {
                field.sortNumber = index
            })
        }
        else {
            let indexes = []
            fields.forEach((field) => {
                indexes.push(field.sortNumber)
            })
            indexes = indexes.sort(function (a, b) {
                return a - b;
            });
            fields.forEach((field, index) => {
                field.sortNumber = indexes[index]
            })

        }

        allfields.forEach((Allfield) => {
            fields.forEach((field) => {
                if (field.name === Allfield.name)
                    Allfield.sortNumber = field.sortNumber
            })
        })

        allfields = allfields.sort(this.byField('sortNumber'));

        let tableContent = document.getElementById('sortableContainer')
        if (tableContent) {
            let scrollLeft = tableContent.scrollLeft
            let scrollTop = tableContent.scrollTop
            localStorage.setItem(`tableScrollLeftTuneMetadata_${this.state.dataset.dataset}`, scrollLeft);
            localStorage.setItem(`tableScrollTopTuneMetadata_${this.state.dataset.dataset}`, scrollTop);
        }
        localStorage.setItem("tableEdit", 0);

        this.setState({ fields: fields, allFields: allfields }, () => { });
    }

    getButtonsLine = (unsetFeatures, title) => {
        if (unsetFeatures) return <div className={title ? 'featuresFreeTitle' : 'featuresFree'}>
            <p className="textBottom">Доступные признаки</p><div className={'featureSelect'}>
                {(unsetFeatures.length > 0)
                    ?
                    unsetFeatures.map((feature, index) => { return <div className='featureFreeElement' key={'feature' + index}><p className='featureText'>{feature}</p></div> })
                    :
                    <div className='featureFreeElement green'><p className='featureText greenText'>все признаки выбраны</p></div>
                }
            </div>
        </div>
    }

    newFieldDiv = (title) => {
        return <div className={title ? 'featuresFreeTitle' : 'featuresFree'}>
            <div className={'addNewDropdownAndText'}> <p className="textBottom" onClick={() => { }}>Новое поле</p>
                <div className="featureNewElement" onClick={() => {
                    if (this.STANDART_FIELDS[this.state.newFieldName]) {
                        this.STANDART_FIELDS[this.state.newFieldName].forEach((field) => {
                            this.addNewField(field.name, field.caption, field.type, field.feature);
                        })
                    }
                    else {
                        this.addNewField();
                    }
                }}>
                    Добавить
                </div>

            </div>

            <div className={'addNewInputButton'}>
                <input className={'newInput'} value={this.state.newFieldName && this.state.newFieldName} placeholder={'Bведите'} type={'text'} onChange={(event) => this.setNewFieldName(event.target.value)} />
                <Dropdown className="dropdownNew">
                    <Dropdown.Toggle className="dropdownNewField" id="dropdown-basic">
                        {"или выберите"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {Object.entries(this.STANDART_FIELDS).map((fieldsArray, index2) => (
                            <Dropdown.Item key={index2} onClick={() => {
                                this.setNewFieldName(fieldsArray[0])
                            }}>{fieldsArray[0]}</Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </div>

            {/* {this.state.newFieldError && <p className="errorMessage">{this.state.newFieldError}</p>} */}
        </div>
    }

    render() {

        let SortableItem = sortableElement((field) => {
            let DragHandle = sortableHandle(() => <div className='sortableIcon'><img alt='DragIcon' src={DragIcon} /></div>);
            let DeleteCell = (props) => {
                let field = props.field
                return <div className='redButton' onClick={() => this.changeField(field, null, null, null, true)}>Удалить</div>
            }
            let InputDiv = (props) => {
                let field = props.field
                let value = props.value

                let onChangeFunction = (event) => {

                    this.changeField(field, event.target.value, null, null, false)

                }

                return <input id={'input' + field.name} className={'cellInput'} defaultValue={value} type={'text'} onChange={(event) => onChangeFunction(event)} />
            }

            let TypeDiv = (props) => {
                let field = props.field
                return (<Dropdown className="dropdownMeta">
                    <Dropdown.Toggle className="dropdownMetaButton" id="dropdown-basic">
                        {this.TYPES[field.type] ? this.TYPES[field.type] : "выберите"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {Object.entries(this.TYPES).map((typeArray, index2) => (
                            <Dropdown.Item key={index2} onClick={() => {
                                this.changeField(field, null, typeArray[0], null, null)

                            }}>{typeArray[1]}</Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
                )
            }

            let FeatureDiv = (props) => {
                let field = props.field
                let alreadyChoosen = (field.feature && this.FEATURES[field.feature])
                return (<Dropdown className="dropdownMeta">
                    <Dropdown.Toggle className={alreadyChoosen ? "dropdownMetaButton green" : "dropdownMetaButton"} id="dropdown-basic">
                        {alreadyChoosen ? this.FEATURES[field.feature] : "выберите"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {Object.entries(this.FEATURES).map((featureArray, index2) => (
                            <Dropdown.Item key={index2} onClick={() => {
                                this.changeField(field, null, null, featureArray[0], false)
                            }}>{featureArray[1]}</Dropdown.Item>
                        ))}
                        <Dropdown.Item onClick={() => {
                            this.changeField(field, null, null, 'zero', false)
                        }}>никакое</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
                )
            }

            field = field.value
            return (
                <div className='sortableElement'>
                    <div className='sortableRow'>
                        <DragHandle />
                        <div className='sortableRowCell'>{field.name}</div>
                        <div className='sortableRowCell'><InputDiv field={field} value={field.caption} /></div>
                        <div className='sortableRowCell'><TypeDiv field={field} /></div>
                        <div className='sortableRowCell'><FeatureDiv field={field} /></div>
                        <div className='sortableRowCellCenter'><DeleteCell field={field}></DeleteCell></div>
                    </div>
                </div>)
        }
        );
        let SortableTitle = sortableElement(() => {
            let FilterAndSort = (props) => {
                let text = props.title
                let type = props.type

                let onChangeColumn = (event, name) => {
                    let value = event.target.value.toLowerCase()
                    let newArray = []
                    let fields = this.state.allFields


                    fields.forEach((fieldTmp) => {
                        if (name) {
                            if (fieldTmp.name.toLowerCase().includes(value)) newArray.push(fieldTmp)
                        }
                        else {
                            if (fieldTmp.caption.toLowerCase().includes(value)) newArray.push(fieldTmp)
                        }
                    })

                    this.setState({ fields: newArray }, () => {
                        name ? (document.getElementById('filterField') && (document.getElementById('filterField').value = event.target.value.toLowerCase()) && document.getElementById('filterField').focus()) : (document.getElementById('filterCaption') && (document.getElementById('filterCaption').value = event.target.value.toLowerCase()) && document.getElementById('filterCaption').focus())
                    });
                }

                let sortUp = (field, down) => {
                    let fields = this.state.fields
                    if (this.state.sortUpField || this.state.sortUpCaption) {
                        fields = fields.sort(this.byField('sortNumber'))
                        this.setState({ sortUpField: false, sortUpCaption: false, fields: fields })
                    }
                    else {
                        if (field) {
                            fields = fields.sort(this.byField('name'))
                            this.setState({ sortUpField: true, sortDownField: false, sortUpCaption: false, sortDownCaption: false, fields: fields })
                        }
                        else {
                            fields = fields.sort(this.byField('caption'))
                            this.setState({ sortUpField: false, sortDownField: false, sortUpCaption: true, sortDownCaption: false, fields: fields })
                        }

                    }
                }
                let sortDown = (field) => {
                    let fields = this.state.fields
                    if (this.state.sortDownField || this.state.sortDownCaption) {
                        fields = fields.sort(this.byField('sortNumber'))
                        this.setState({ sortDownField: false, sortDownCaption: false, fields: fields })
                    }
                    else {
                        if (field) {
                            fields = fields.sort(this.byFieldDown('name'))
                            this.setState({ sortUpField: false, sortDownField: true, sortUpCaption: false, sortDownCaption: false, fields: fields })
                        }
                        else {
                            fields = fields.sort(this.byFieldDown('caption'))
                            this.setState({ sortUpField: false, sortDownField: false, sortUpCaption: false, sortDownCaption: true, fields: fields })
                        }

                    }
                }

                return <>
                    <p className='sortableRowCellText'>{text}</p>
                    {(type === 'field') && <>
                        <img className={this.state.sortUpField ? 'sortActive' : 'sortIcon'} src={SortUp} alt='SortUpIcon' onClick={() => { sortUp(true) }} />
                        <img className={this.state.sortDownField ? 'sortActive' : 'sortIcon'} src={SortDown} alt='SortDownIcon' onClick={() => { sortDown(true) }} />
                    </>}
                    {(type === 'caption') && <>
                        <img className={this.state.sortUpCaption ? 'sortActive' : 'sortIcon'} src={SortUp} alt='SortUpIcon' onClick={() => { sortUp(false) }} />
                        <img className={this.state.sortDownCaption ? 'sortActive' : 'sortIcon'} src={SortDown} alt='SortDownIcon' onClick={() => { sortDown(false) }} />
                    </>}

                    <img className={this.state.filterField ? 'filteredActive' : 'filterIcon'} src={FilterIcon} alt='filterIcon' onClick={() => {
                        if (type === 'field') {
                            let state = this.state.filterField ? false : true
                            this.setState({ filterField: state, filterCaption: false })
                        }
                        else {
                            let state = this.state.filterCaption ? false : true
                            this.setState({ filterCaption: state, filterField: false })
                        }
                    }}
                    />
                    {(type === 'field') && this.state.filterField && <input id={'filterField'} className={'cellInputTitle'} defaultValue={''} type={'text'} onChange={(event) => onChangeColumn(event, true)} />}
                    {(type === 'caption') && this.state.filterCaption && <input id={'filterCaption'} className={'cellInputTitle'} defaultValue={''} type={'text'} onChange={(event) => onChangeColumn(event, false)} />}


                </>
            }
            return (
                <div className='sortableElement'>
                    <div className='sortableRow'>
                        <div className='sortableTitleIcon'></div>
                        <div className='sortableRowCellCenterLeft'><FilterAndSort title='Поле' type='field' /></div>
                        <div className='sortableRowCell titleBorder'><FilterAndSort title='Название' type='caption' /></div>
                        <div className='sortableRowCell titleBorder'><p className='sortableRowCellText'>Тип</p></div>
                        <div className='sortableRowCell titleBorder'><p className='sortableRowCellText'>Признак</p></div>
                        <div className='sortableRowCellCenter titleBorder'><></></div>
                    </div>
                </div>)
        }
        );

        let SortableContainer = sortableContainer(({ children }) => {
            return <div className='sortableContainer' id='sortableContainer'>{children}</div>;
        });

        let SortableTitleContainer = sortableContainer(({ children }) => {
            return <div className='sortableTitleContainer'>{children}</div>;
        });


        let fields = null;
        let unsetFeatures = null;
        if (this.state.dataset) {
            fields = this.state.fields;
            if (!this.state.sortDownField && !this.state.sortUpField && !this.state.sortUpCaption && !this.state.sortDownCaption) fields = fields.sort(this.byField('sortNumber'));
            unsetFeatures = DatasetUtils.unsetConnectingFeatures(this.state.allFields);
        }

        return (
            <div id={"tuneMetadata"} className="flexColumn rightPanel" >
                {/* {this.renderAlerts()} */}

                <div className='headerWithTitleContainer'>
                    <div className='headerWithTitle'>
                        <div className="headerContainer">
                            <img src={BackArrow} className='backArrow' alt='back arrow' onClick={() => this.props.navigation(-1)} />
                            <div className='titleContainer'><p className="headerMargin">{this.sectionName(actionTypes.TUNE_METADATA)}</p></div>
                        </div>

                        {this.state.dataset && <div className="bottomHeaderContainer">
                            <input
                                className="newInput"
                                type="text"
                                placeholder="Название набора"
                                value={this.state.datasetName}
                                onChange={(event) => { this.setState({ datasetName: event.target.value }) }}
                            />
                        </div>}
                    </div>
                    <div className='buttonsLineContainer'>
                        {this.state.dataset && this.getButtonsLine(unsetFeatures, true)}
                        {this.state.dataset && this.newFieldDiv(true)}
                    </div>
                </div>

                {<div className="postHeaderContainer textRoboto infoContainer">
                    {this.state.dataset &&
                        <>
                            <SortableTitleContainer
                                onSortEnd={this.onSortEnd}
                                useDragHandle
                            >
                                <SortableTitle key={`item-title`} index={0} />
                            </SortableTitleContainer>

                            <SortableContainer
                                onSortEnd={this.onSortEnd}
                                onSortStart={(_, event) => {
                                    event.preventDefault();
                                    localStorage.setItem("tableEdit", 1);
                                }}
                                useDragHandle
                            >
                                {fields && fields.map((field, index) => (
                                    <SortableItem
                                        key={`item-${field.name}` + index}
                                        index={index}
                                        value={field}
                                    />
                                ))}
                            </SortableContainer>

                            <Button variant="primary" className="applyInstrument" onClick={() => { this.saveStructure(); }}>Сохранить</Button>
                        </>
                    }
                    {this.state.afterSave && <div className='postHeaderSaveAlert'><p className={this.state.afterSave === 'Cохранено' ? 'greenSave' : 'redError'}>{this.state.afterSave}</p></div>}
                </div>}
                {this.state.message}
            </div >
        );
    }
}

